var CancellableEvent = /** @class */ (function () {
    function CancellableEvent(canContinue) {
        this.canContinue = canContinue;
        this.hasCancelled = false;
    }
    CancellableEvent.prototype.cancel = function () {
        this.hasCancelled = true;
    };
    CancellableEvent.prototype.tryRunAction = function (action) {
        if (this.hasCancelled) {
            this.cancelledAction = action;
        }
        else {
            action();
        }
    };
    CancellableEvent.prototype.continue = function () {
        if (this.cancelledAction === undefined) {
            throw Error("continue() cannot be called multiple times, or if the event was not cancelled.");
        }
        if (this.canContinue()) {
            this.cancelledAction();
        }
        this.cancelledAction = undefined;
    };
    return CancellableEvent;
}());
export { CancellableEvent };
